module.exports = __webpack_public_path__ + "static/media/Protones - Scritta Rosso Scuro.8c016933.png";